import { render, staticRenderFns } from "./StaticLandingPage.vue?vue&type=template&id=45e0796a&scoped=true&"
import script from "./StaticLandingPage.vue?vue&type=script&lang=js&"
export * from "./StaticLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./StaticLandingPage.vue?vue&type=style&index=0&id=45e0796a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0796a",
  null
  
)

export default component.exports